module.exports = __webpack_public_path__ + "img/mickey84.2ff0ab71.jpg";